<template>
  <div class="d-flex justify-center">
    <v-btn icon color="primary" large @click="viewLogs">
      <v-icon size="22">mdi-history</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  methods: {
    viewLogs() {
      this.params.context.parentComponent.openDraftSubHireLogs(this.params.data);
    },
  },
};
</script>
